import { Button, Text } from '@ksyos/design-system';
import { useState } from 'react';
import { translateKey } from '../../translate';
import { Modal } from './modals/Modal';

interface IProceedWithOnlyAdditionalFilesProps {
    onNo: () => void | Promise<void>;
    onYes: () => void | Promise<void>;
}

export function ProceedWithOnlyAdditionalFiles(props: IProceedWithOnlyAdditionalFilesProps) {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    return (
        <Modal
            actionButtons={[
                <Button
                    onClick={props.onNo}
                    variant="outline"
                >
                    {translateKey('common.no')}
                </Button>,
                <Button
                    isDisabled={isSaving}
                    onClick={async () => {
                        setIsSaving(true);
                        await props.onYes();
                    }}
                >
                    {translateKey('common.yes')}
                </Button>,
            ]}
            isOpen
            onClose={props.onNo}
            size="small"
            title={translateKey('common.sendForm')}
        >
            <Text>{translateKey('request.proceedWithOnlyAdditionalFiles', translateKey('processType.procedure'))}</Text>
        </Modal>
    );
}
